/**
 * 认证相关的工具函数
 */

/**
 * 从cookie中获取指定的值
 */
export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    const encodedValue = parts.pop()?.split(';').shift() || null
    // 添加URL解码
    return encodedValue ? decodeURIComponent(encodedValue) : null
  }
  return null
}

/**
 * 设置cookie
 */
export function setCookie(name: string, value: string, days: number = 7, domain?: string) {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)

  let cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`

  if (domain) {
    cookie += `; domain=${domain}`
  }

  document.cookie = cookie
}

/**
 * 删除cookie
 */
export function deleteCookie(name: string, domain?: string) {
  let cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`

  if (domain) {
    cookie += `; domain=${domain}`
  }

  document.cookie = cookie
}

/**
 * 清除所有认证相关的cookie
 * 注意：需要同时清除不同domain的cookie，确保完全清理
 */
export function clearAuthCookies() {
  const authCookies = ['token', 'userid', 'username', 'encrypt']
  const domain = 'snsys.xiujiadian.com' // 与后端cookie domain保持一致

  authCookies.forEach(cookieName => {
    // 删除不带domain的cookie
    deleteCookie(cookieName)
    // 删除带domain的cookie
    deleteCookie(cookieName, domain)
    // 删除带.domain的cookie（有些浏览器会添加点前缀）
    deleteCookie(cookieName, `.${domain}`)
  })

  console.log('已清除所有认证cookie')
}

/**
 * 检查用户是否已登录（仅检查基本cookie，真正验证由后端处理）
 */
export function isAuthenticated(): boolean {
  // 只检查token，因为它是唯一非HttpOnly的cookie
  const token = getCookie('token')

  return !!token
}

/**
 * 获取当前登录的用户信息
 */
export function getCurrentUser() {
  return {
    userid: getCookie('userid'),
    username: getCookie('username')
  }
}

/**
 * 登出并跳转到登录页
 */
export function logout() {
  console.log('👋 用户主动登出')
  clearAuthCookies()

  // 确保cookie清理完成后再跳转
  setTimeout(() => {
    window.location.href = '/login'
  }, 100)
}

/**
 * 解析 JWT Token
 * @param token JWT token字符串
 * @returns 解析后的payload对象，解析失败返回null
 */
export function parseJwt(token: string): any {
  try {
    const base64Url = token.split('.')[1] // 取中间的payload部分
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(jsonPayload) // 返回对象
  } catch (e) {
    console.error('Invalid JWT Token:', e)
    return null
  }
}

/**
 * 调试工具：检查当前认证状态
 */
export function debugAuthState() {
  console.log('  认证状态调试信息:')
  console.log('  - username:', getCookie('username'))
  console.log('  - userid:', getCookie('userid') || '(HttpOnly，前端无法读取)')
  console.log('  - token:', getCookie('token') || '(HttpOnly，前端无法读取)')
  console.log('  - encrypt:', getCookie('encrypt') || '(HttpOnly，前端无法读取)')
  console.log('  - isAuthenticated:', isAuthenticated())
  console.log('  - 所有cookies:', document.cookie)
}


